import { IFieldType, IFormFields } from "shared/types";
import { copy } from "shared/assets";
import { ISelectOption } from "shared/components/Form/Fields/select/types";

const fieldCopy = copy.venueBlock.stageCapacity.fields;

export const getFields = ({
  stages = [],
  capcities = [],
  handleChangeStage = () => {},
  handleChangeCapacity = () => {},
  showCapacityField,
}: {
  stages?: ISelectOption[];
  capcities?: ISelectOption[];
  handleChangeStage?: (stageId: string) => void;
  handleChangeCapacity?: (capacityId: string) => void;
  showCapacityField?: boolean;
}): IFormFields => {
  let fields: IFormFields = [
    {
      type: IFieldType.select,
      name: "stage",
      label: fieldCopy.stage.title,
      options: stages,
      placeholder: fieldCopy.stage.placeholder,
      onChange: (value: ISelectOption) => {
        handleChangeStage(value?.value);
      },
      style: {
        gridColumn: "1",
        mobile: {
          gridColumn: "auto",
        },
      },
    },
  ];

  if (showCapacityField && capcities.length) {
    fields.push({
      type: IFieldType.select,
      name: "capacity",
      label: fieldCopy.capacity.title,
      options: capcities,
      placeholder: fieldCopy.capacity.placeholder,
      onChange: (value: ISelectOption) => {
        handleChangeCapacity(value?.value);
      },
      style: {
        gridColumn: "2",
        mobile: {
          gridColumn: "auto",
        },
      },
    });
  }

  return fields;
};
